const range = (min: number, max: number): number[] =>
  Array.from({ length: max - min + 1 }, (_, i) => min + i)

export const getYarRange = (maxAge: number, minAge = 18): number[] => {
  const currentYear = new Date().getFullYear()
  const maxYear = currentYear - minAge
  return range(maxYear - maxAge, maxYear)
}
